import WebGalleryActionBarButton from './WebGalleryActionBarButton';

export default WebGalleryActionBarButton;
